module.exports = __webpack_public_path__ + "img/10b.85b0910e.png";